import { escapeHtml, matchHtml, readMatchPairs, replaceWidgetNode } from './markup';
import { bindRepeatable, dialogStyles as s, itemRow, openFormDialog } from './dialogHelpers';

const pairFields = (pair = {}) =>
  `<div class="${s.pair}">
    <label class="${s.field}"><span>Term</span>
      <input class="jodit-input mc-match-term" type="text" placeholder="Left side" value="${escapeHtml(
        pair.term || '',
      )}" />
    </label>
    <label class="${s.field}"><span>Definition</span>
      <input class="jodit-input mc-match-def" type="text" placeholder="Right side (dragged)" value="${escapeHtml(
        pair.definition || '',
      )}" />
    </label>
  </div>`;

const pairRow = (pair = {}) =>
  itemRow({ label: 'Pair', fields: pairFields(pair) });

export const openMatchDialog = (editorInstance, existingNode = null) => {
  const pairs = existingNode
    ? readMatchPairs(existingNode)
    : [
        { term: '', definition: '' },
        { term: '', definition: '' },
      ];

  const { dialog, form } = openFormDialog(editorInstance, {
    title: existingNode ? 'Edit match activity' : 'Insert match drag-and-drop',
    submitLabel: existingNode ? 'Update' : 'Insert',
    minWidth: 560,
    errorMessage: 'Add at least two complete pairs.',
    html: `<p class="${s.hint}">Learners drag each definition onto the matching term. This is practice only — it does not count toward the lesson grade.</p>
      <div class="${s.list}">${pairs.map(pairRow).join('')}</div>
      <button type="button" class="jodit-ui-button ${s.add}">+ Add pair</button>`,
    onSubmit: (submittedForm) => {
      const next = [...submittedForm.querySelectorAll(`.${s.row}`)]
        .map((row) => ({
          term: row.querySelector('.mc-match-term')?.value.trim() || '',
          definition: row.querySelector('.mc-match-def')?.value.trim() || '',
        }))
        .filter((pair) => pair.term && pair.definition);
      if (next.length < 2) {
        return false;
      }
      replaceWidgetNode(editorInstance, existingNode, matchHtml(next));
      return true;
    },
  });

  bindRepeatable(form, dialog, {
    listSelector: `.${s.list}`,
    rowSelector: `.${s.row}`,
    addSelector: `.${s.add}`,
    makeRow: () => pairRow(),
  });
};

export const getMatchButton = () => ({
  name: 'mcMatch',
  tooltip: 'Match drag-and-drop',
  exec: (editorInstance) => openMatchDialog(editorInstance),
});
